import localeText from "../../../../../locale";

export function safeLocaleText(key, fallback = "") {
  try {
    const t = localeText(key);
    return t != null && t !== "" ? t : fallback;
  } catch {
    return fallback;
  }
}
